import React, { useEffect } from 'react';

import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { postOfficeGasv3ListenerStore } from '../store';

export const useGasv3Listener = (eventToMatch: AnalyticsEventPayload) => {
	const { subscribe } = postOfficeGasv3ListenerStore;
	const [showMessage, setShowMessage] = React.useState(false);

	useEffect(() => {
		return subscribe(eventToMatch, () => setShowMessage(true));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [eventToMatch]);

	return showMessage;
};
